<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="my_cover"></a>
<svg height="100%" version="1.1" viewbox="0 0 567 754" width="100%" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
<rect fill="#000007" height="680" width="510" x="0" y="0"></rect>
<image height="680" transform="translate(0 0)" width="510" xlink:href="../images/MSRCover.png"></image>
</svg>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?c3b7a77e